import { useMemo } from 'react';
import { Grid, HStack, VStack } from '@cbhq/cds-web/layout';
import { Link, TextBody, TextHeadline } from '@cbhq/cds-web/typography';

import { useSimpleBreakpoints } from ':cloud/hooks/useSimpleBreakpoints';
import { BaseL3Chain } from ':cloud/types/ts_types';
import { BASE_APPCHAIN_BRIDGE_LINK } from ':cloud/utils/links';

import { FULL_PAGE_MAX_WIDTH } from '../product/constants';

type BaseAppchainLinkCardsProps = {
  chain?: BaseL3Chain;
};
export function BaseAppchainLinkCards({ chain }: BaseAppchainLinkCardsProps) {
  const { isDesktop } = useSimpleBreakpoints();
  const responsiveTemplateColumns = useMemo(() => {
    return isDesktop ? '1fr 1fr' : '1fr';
  }, [isDesktop]);

  const linkCards = useMemo(() => {
    return [
      {
        label: 'Bridge',
        link: (
          <Link href={BASE_APPCHAIN_BRIDGE_LINK} openInNewWindow>
            <TextHeadline as="p" color="primary">
              Bridge with OnchainKit
            </TextHeadline>
          </Link>
        ),
        description: 'Easily deploy a bridge with the pre-built OnchainKit component.',
      },
      {
        label: 'Block explorer',
        link: (
          <Link href={chain?.resources?.blockExplorerUrl} openInNewWindow>
            <TextHeadline as="p" color="primary">
              Go to explorer
            </TextHeadline>
          </Link>
        ),
        description: 'View your appchain on your own block explorer.',
      },
    ];
  }, [chain?.resources?.blockExplorerUrl]);

  return (
    <Grid maxWidth={FULL_PAGE_MAX_WIDTH} templateColumns={responsiveTemplateColumns} gap={5}>
      {linkCards.map((card) => {
        return (
          <VStack
            key={card?.label}
            justifyContent="space-between"
            gap={10}
            bordered
            borderRadius="roundedLarge"
            spacing={5}
          >
            <HStack justifyContent="space-between" gap={2}>
              <TextHeadline as="label" color="foregroundMuted">
                {card.label}
              </TextHeadline>
              {card.link}
            </HStack>
            <TextBody as="p">{card.description}</TextBody>
          </VStack>
        );
      })}
    </Grid>
  );
}
